import {
  arrayOf, bool, func, shape, string,
} from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { Image, View } from 'react-native';
import { Link, Route } from 'react-router-dom';
import { Consumer } from 'context';

import { C } from 'common';
import { LAYOUT } from 'reactor/common';
import {
  Button, Icon, InputSelect, Text, Touchable,
} from 'reactor/components';
import { Tooltip } from '..';
import ASSETS from 'assets';
import Finder from './components/Finder';
import styles from './Header.style';
import { onAgency, onLogout } from '../../containers/Agency/containers/SignIn/modules';


const {
  CONTAINERS, LAYOUT: { LOGO, LOGO_AGENCY }, LOGOUT, START, URL,
} = C;
const { VIEWPORT: { PORTRAIT } } = LAYOUT;
const listTooltip = [
  { id: 'start', label: 'start', link: URL.AGENCY },
  { id: 'bookings', label: 'bookings', link: `${URL.AGENCY}/bookings` },
  { id: 'invoices', label: 'invoices', link: `${URL.AGENCY}/invoices` },
  { id: 'users', label: 'MANAGE_USERS', link: `${URL.AGENCY}/users` },
  { id: 'logout', label: 'logout', link: `${URL.AGENCY}/logout` },
];

class Header extends PureComponent {
  static propTypes = {
    agency: string,
    buttons: arrayOf(shape),
    finder: bool,
    onMenu: func,
    profile: string,
    subtitle: string,
    title: string,
  };

  static defaultProps = {
    agency: undefined,
    buttons: [],
    finder: false,
    onMenu() {},
    profile: undefined,
    subtitle: undefined,
    title: undefined,
  };

  state = {
    agency: false,
    tooltip: false,
  }

  async componentDidMount() {
    const { agency, onData } = this.props;
    this.setState({ agency: agency && window.location.pathname.includes(URL.AGENCY) });

    if (agency) {
      const agencyData = await onAgency(agency);
      onData('agency', agencyData);
      this.setState({ agency: agencyData });
    }
  }

  _onTooltip = () => {
    const { tooltip } = this.state;
    this.setState({ tooltip: !tooltip });
  }

  _onAfilliate = () => {
    window.location = '/affiliate/profile';
  }

  _onLink = async (item) => {
    const { _onTooltip } = this;

    if (item.toLowerCase() === LOGOUT) onLogout();
    if (item.toLowerCase() === START) window.location = URL.ACTIVITY_SEARCH;

    _onTooltip();
  }

  render() {
    const {
      _onLink, _onAfilliate, _onTooltip,
      props: {
        buttons, finder, onMenu, profile, title,
      },
      state: { agency, tooltip },
    } = this;
    const { VIEWPORT: { LANDSCAPE } } = LAYOUT;

    return (
      <Consumer>
        { ({ l10n }) => (
          <View style={[styles.container, LANDSCAPE && styles.containerLandscape]}>
            <View style={[PORTRAIT && styles.contentPortrait]}>
              <Link to={!agency && '/'}>
                <Image
                  onClick={() => agency && _onLink('start')}
                  resizeMode="contain"
                  source={{ uri: agency ? LOGO_AGENCY : LOGO }}
                  style={styles.logo}
                />
              </Link>
              { !LANDSCAPE && <Button icon={ASSETS.menu} onPress={onMenu} noPadding contained={false} style={styles.buttonMenu} /> }
            </View>

            <Route path="/:container">
              { ({ match, history }) => {
                const { params: { container } = {} } = match || {};

                return (
                  !container
                    ? (
                      <InputSelect
                        dataSource={['Select...', ...CONTAINERS]}
                        onChange={item => (
                          CONTAINERS.indexOf(item) >= 0 ? history.push(`/${item}`) : undefined
                        )}
                        style={styles.inputPicker}
                        value={container}
                      />)
                    : <View />
                );
              }}
            </Route>

            <View style={styles.actions}>
              { finder && LANDSCAPE && <Finder /> }
              { !PORTRAIT && profile && (
                <Fragment>
                  <Touchable onPress={agency ? () => _onTooltip() : () => _onAfilliate()} style={styles.touchable}>
                    <View style={styles.profile}>
                      {title && <Text headline level={6} lighten>{title.substr(0, 1).toUpperCase()}</Text>}
                    </View>
                    {agency && <Icon value="navArrow" style={styles.icon} />}
                  </Touchable>
                  { agency && tooltip && (
                    <Tooltip title={agency.name}>
                      {listTooltip.map(item => (
                        <Link to={item.link} onClick={() => _onLink(item.id)} style={{ textDecoration: 'none', marginBottom: '12px' }}>
                          <Text subtitle level={2}>{l10n[item.label.toUpperCase()]}</Text>
                        </Link>
                      ))}
                    </Tooltip>
                  )}
                </Fragment>
              )}
              { buttons.map(button => (
                <Button
                  key={button.title}
                  outlined
                  responsive
                  style={styles.button}
                  {...button}
                />))}
            </View>
          </View>
        )}
      </Consumer>
    );
  }
}

export default Header;
